import React from "react";

import "./notification.style.scss";
export default function Notification({
  closeIt,
  enabled,
  title,
  moreDetails ,
}) {
  return (
    <div style={!title?{animation: "none"}:{}} onClick={() => closeIt()} className={`notification-portal ${enabled?"":"closing-it"}`}>
      <div onClick={(e) => e.stopPropagation(0)} className="notification-box">
        <button onClick={() => closeIt()}>
        <img src="https://img.icons8.com/fluency-systems-filled/48/000000/cancel.png"/>
        </button>
        <h5>{title}</h5>
        <div>
          <p>{moreDetails}</p>
        </div>
      </div>
    </div>
  );
}
